import { gql } from '../../../apollo/__generated__';

export const UNCONFIRM_USER_HERE = gql(`
  mutation UnConfirmUserHere($userId: ID!, $eventId: ID!) {
    unconfirmUserHere(userId: $userId, eventId: $eventId) {
      id
      isHere(eventId: $eventId)
    }
  }
`);
